import {
  MONSTER_CONFIGS,
  MonsterBaseConfig,
  LootEntry,
} from '../data/monsters.config';
import { ITEMS } from '../data/inventory.config';
import { BestiaryEntry } from '../types/bestiary.types';

export interface BestiaryLootDisplay {
  itemId: string;
  /** Icons-atlas frame, or undefined → Icon placeholder. */
  sprite?: string;
  /** Icon frame overlaid bottom-right (e.g. spell on a grimoire). */
  overlay?: string;
  label: string;
  /** True if the drop comes from `eliteLoot` (elite-only). */
  eliteOnly: boolean;
  /** Drop probability 0..1. */
  chance: number;
  quantityMin: number;
  quantityMax: number;
}

export interface BestiaryCardData {
  config: MonsterBaseConfig;
  loot: BestiaryLootDisplay[];
}

function resolveLoot(
  entries: LootEntry[] | undefined,
  eliteOnly: boolean,
): BestiaryLootDisplay[] {
  return (entries ?? []).map((e) => {
    const item = ITEMS[e.itemId];
    return {
      itemId: e.itemId,
      sprite: item?.sprite,
      overlay: item?.iconOverlay,
      label: item?.label ?? e.itemId,
      eliteOnly,
      chance: e.chance,
      quantityMin: e.quantityMin,
      quantityMax: e.quantityMax,
    };
  });
}

/** All possible drops for the card: standard loot + elite-only loot. */
export function getBestiaryLoot(
  config: MonsterBaseConfig,
): BestiaryLootDisplay[] {
  return [
    ...resolveLoot(config.loot, false),
    ...resolveLoot(config.eliteLoot, true),
  ];
}

/** Killed monsters as card data, sorted by `bestiaryId` ascending. */
export function getKilledMonsterCards(
  entries: Record<string, BestiaryEntry>,
): BestiaryCardData[] {
  return Object.keys(entries)
    .map((id) => MONSTER_CONFIGS[id])
    .filter((c): c is MonsterBaseConfig => Boolean(c))
    .sort((a, b) => a.bestiaryId - b.bestiaryId)
    .map((config) => ({ config, loot: getBestiaryLoot(config) }));
}
